import Translatable from '../translatable_text/Translatable';
import { useContext } from 'react';
import { AuthContext } from '@/context/authContext';
import { Conditional } from '../conditional-render/ConditionalRender';
import LanguageAction from '../languageAction/LanguageAction';

function Footer() {

  const { currentUser, logout } = useContext(AuthContext)

  return (
    <footer
      className="clean-footer crev bg-img"
      data-background="/light/assets/imgs/header/bg1.webp"
      data-overlay-dark="10"
    >
      <div className="max-w-7xl mx-auto px-20 lg:px-4 pb-40 section-padding ontop">
        <div className="cal-action pb-50 mb-80 bord-thin-bottom">
          <h2 className="fz-120 line-height-1 d-rotate wow">
            <span className="rotate-text">
              <a aria-label='link to contact' href="/contact">
                <Translatable>Let’s Contact</Translatable>{' '}
                <span className="ml-30 fz-70 ti-arrow-top-
                "></span>
              </a>
            </span>
          </h2>
        </div>
        <div className="flex flex-wrap">
          <div className="w-full lg:w-3/12  md:w-6/12">
            <div className="logo icon-img-100">
              <img style={{ width: 200 }} src="/light/assets/imgs/logo/gcadlogo.webp" loading='lazy' width="200px" height="100%" alt="logo" />
            </div>
          </div>
          <div className="w-full lg:w-4/12 md:w-6/12">
            <div className="column">
              <div className="mb-40">
                <h2 className="sub-title mb-30">
                  <Translatable>Address</Translatable>
                </h2>
                <h3 className="opacity-8">
                  Al Shoqiyah, Mecca 25553
                </h3>
              </div>

              <a href="tel:+966595951565" aria-label='link to home' className="underline">
                <span className="fz-22 main-color">+966 59 595 1565</span>
              </a>
              <div>

              <a href="mailto:co@begining.online" aria-label='link to emial' className="underline">
                <span className="fz-22 main-color">co@begining.online</span>
              </a>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-2/12 md:w-6/12 lg:ml-[8.333333%]">
            <div className="column">
              <h6 className="sub-title mb-30">
                  <Translatable>
                    Useful Links
                  </Translatable>
                </h6>
              <ul className="rest fz-14">
                <li className="mb-15">
                  <a className="link-hover-effect" href="/about">
                    <Translatable>
                      About Us
                    </Translatable>
                  </a>
                </li>
                <li className="mb-15">
                  <a className="link-hover-effect" href="/join-the-team">
                    <Translatable>
                      Join Us
                    </Translatable>
                  </a>
                </li>
                <li className="mb-15">
                  <a className="link-hover-effect" href="/services">
                    <Translatable>
                      Services
                    </Translatable>
                  </a>
                </li>
                <li className="mb-15">
                  <a className="link-hover-effect" href="/contact"><Translatable>Contact</Translatable></a>
                </li>
                <li className='hidden'>
                  <a className="link-hover-effect" href='#'>
                    <LanguageAction/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="w-full lg:w-2/12 md:w-6/12">
            <div className="column">
              <h6 className="sub-title mb-30">
                 <Translatable>
                    Support
                  </Translatable>
                </h6>
              <ul className="rest fz-14">
                <li className="mb-15">
                  <a className="link-hover-effect" href="/">
                    <Translatable>
                      FAQS
                    </Translatable>
                  </a>
                </li>
                <li className="mb-15">
                  <a className="link-hover-effect" href="/">
                     <Translatable>
                      Term & Conditions
                    </Translatable>
                  </a>
                </li>
                <li className="mb-15">
                  <a className="link-hover-effect" href="/">
                        <Translatable>
                      Privacy policy
                    </Translatable>
                  </a>
                </li>
                <li className="mb-15">
                  <h6 className="sub-title mt-30 mb-20">
                    <Translatable>
                      Admin
                    </Translatable>
                  </h6>
                  <Conditional
                    condition={currentUser?.name === "Admin"}
                    fallback={ 
                        <a className="link-hover-effect mb-15" href="/auth/login">
                          <Translatable>
                            Login
                          </Translatable>
                        </a>
                    }
                  >
                    <div className='flex flex-col'>
                        <a className="link-hover-effectx mb-15" href={"/admin/dashboard"}>
                          <Translatable>
                            Dashboard
                          </Translatable>
                        </a>
                        <span style={{ color: 'red', cursor: 'pointer'}} onClick={() => logout()}>
                          <Translatable>
                            Logout
                          </Translatable>
                        </span>
                    </div>
                  </Conditional>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex items-center pt-30 pb-30 mt-80 bord-thin-top">
          <div>
            <ul className="rest flex items-center centered-element-resp">
              <li className="hover-this cursor-pointer ml-30">
                <a href="https://x.com/GCAD_SA" className="hover-animx" aria-label='link button' target='_blank'>
                  <i className="fab fa-twitter"></i>
                </a>
              </li>
              <li className="hover-this cursor-pointer ml-30">
                <a href="https://www.linkedin.com/company/gcad-sa/" rel="noreferrer" aria-label='link button' className="hover-animx" target='_blank'>
                  <i className="fab fa-linkedin-in"></i>
                </a>
              </li>
              <li className="hover-this cursor-pointer ml-30">
                <a href="/" className="hover-animx" aria-label='link button' target='_blank'>
                  <i className="fab fa-facebook-f"></i>
                </a>
              </li>
            </ul>
          </div>
          <div className="ml-auto">
              <p className="ltr:hidden fz-14">
                 © {' '} 2025 GCAD مدعوم من قبل {' '} 
                <span className="underline main-color">
                  <a href="/" target="_blank" aria-label='clickable btn' rel="noreferrer">
                    BEGINING
                  </a>
                  {' '}
                 
                </span>
              </p>
              <p className="rtl:hidden fz-14">
                © 2025 GCAD is Powered by{' '}
                <span className="underline main-color">
                  <a href="/" aria-label='clickable btn' target="_blank" rel="noreferrer">
                    BEGINING
                  </a>
                </span>
              </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
